// extracted by mini-css-extract-plugin
export default {"layout":"index_layout_p7NlT","br":"index_br_-iyPt","more":"index_more_6Wc33","bottom":"index_bottom_A3s31","download":"index_download_JIT08"};